class BackToTop {
    constructor(buttonId, options = {}) {
      this.button = document.getElementById(buttonId);
      this.scrollThreshold = options.scrollThreshold || 300;
      this.scrollBehavior = options.scrollBehavior || 'smooth';
      
      this.init();
    }
    
    init() {
      if (!this.button) return;

      window.addEventListener('scroll', () => this.toggleButton());
      this.button.addEventListener('click', () => this.scrollToTop());
    }

    toggleButton() {
      if (window.scrollY > this.scrollThreshold) {
        this.button.classList.add('show');
      } else {
        this.button.classList.remove('show');
      }
    }

    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: this.scrollBehavior
      });
    }
  }

const backToTop = new BackToTop('backToTop', {
    scrollThreshold: 200,
    scrollBehavior: 'smooth'
});